import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";
import { HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs/internal/observable/throwError";
import { BehaviorSubject } from "rxjs";
import { GlobalCurrentUserService } from '../pages/Services/global-current-user.service';
import { API } from './end-points';
import { NetworkService } from './network.service';
import { EvoGlobalService } from '../globals/evo-global.service';
import { SpecialService } from './special.service';
import { SharedService } from '../pages/Services/shared.service';
import { CookieService } from "ngx-cookie-service";
import { secureStorage, getSecureItem } from '../pages/Services/secure-storage'

@Injectable()
export class APIConfigService {
  public apiHost: string;
  public basicApiHost: string;
  public static errorFromApi: BehaviorSubject<{
    success: boolean;
    status: number;
    message: string;
  }>;
  static userName: any;
  static password: any;
  constructor(private globalCurrentUserService: GlobalCurrentUserService,
    private sharedService: SharedService,
    public cookieService: CookieService) {
    APIConfigService.errorFromApi = new BehaviorSubject({
      success: true,
      status: 0,
      message: "",
    });
    //this.apiHost = environment.apiHost;
    //this.basicApiHost = environment.basicApiHost;
    this.sharedService.getConfig().subscribe(result => {
      if (result) {
        this.apiHost = result["apiHost"];
        this.basicApiHost = result["basicApiHost"];
        APIConfigService.userName = result["username"];
        APIConfigService.password = result["basicAuthPassword"];
      }
    });
  }
  static getHeaders(apiEndPoint: string): HttpHeaders {
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let authorizationData = "Basic " + btoa(APIConfigService.userName + ":" + APIConfigService.password);
    return new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId
    });
  }

  getAcessTokenHeaders(): HttpHeaders {
    // let langId = APIConfigService.getLanguage().toString(); 
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    let headers;
    this.cookieService.check(encr) ? (headers = new HttpHeaders({
      "Content-Type": "application/json",
      authorization:"Bearer " +  accessToken.accessToken,
      "languageId": langId,
    })) : (headers = new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId
    }));
    return headers;
  }

  getAcessTokenHeadersForMultipartData(): HttpHeaders {
    // let langId = APIConfigService.getLanguage().toString(); 
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    let headers;
    this.cookieService.check(encr) ? (headers = new HttpHeaders({
      // "Content-Type": "false",
      authorization: accessToken.accessToken,
      "languageId": langId,
      // "processData": "false"
    })) : (headers = new HttpHeaders({
      // "Content-Type": "false",
      // "processData": "false",
      // "languageId": langId
    }));
    return headers;
  }



  getAcessTokenHeadersForText(): HttpHeaders {
    // let langId = APIConfigService.getLanguage().toString(); 
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    let headers;
    this.cookieService.check(encr) ? (headers = new HttpHeaders({
      "Content-Type": "application/json",
      authorization: accessToken.accessToken,
      "languageId": langId
    })) : (headers = new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId
    }));
    return headers;
  }

  getAcessTokenHeadersForceChangePassword(): HttpHeaders {
    // let langId = APIConfigService.getLanguage().toString();
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    //   let accessToken = JSON.parse(localStorage.getItem("currentUser"));

    //   return new HttpHeaders({
    //     "Content-Type": "application/json",
    //     authorization: accessToken.accessToken,
    //     "languageId": langId
    // }); 
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    let headers;
    this.cookieService.check(encr) ? (headers = new HttpHeaders({
      "Content-Type": "application/json",
      authorization: accessToken.accessToken,
      "languageId": langId
    })) : (headers = new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId
    }));
    return headers;
  }
  //   async getRefreshToken(){
  //   console.log("check If token expired");
  //   let accessToken = JSON.parse(localStorage.getItem("currentUser"));
  //   if(accessToken!=null){

  //     let MS_PER_MINUTE = 60000;

  //   let expiresIn:any = new Date(accessToken.expiresIn);
  //   let currentDate:any = new Date();
  //   expiresIn = new Date(expiresIn - 2 * MS_PER_MINUTE);
  //   console.log(expiresIn);
  //   if(currentDate > expiresIn){
  //     console.log("Token Expired");
  //   let temp:any;
  //   let response= await this.specialService.refreshToken(temp, API.REFRESH_TOKEN.REFRESH);
  //   console.log("Token updated");
  //   this.globalCurrentUserService.setCurrentUser(
  //     JSON.stringify({accessToken:response["accessToken"], refreshToken:response["refreshToken"], expiresIn:response["expiresIn"]})
  //   );
  //   }
  // }


  // }

  static getToken(): any {
    return localStorage.getItem(environment.tokenName);
  }

  static handleError(response: Response | any) {
    // let errorMessage: any = {};
    // // Connection error
    // if (response.error.errors) {
    //     errorMessage = {
    //         success: false,
    //         status: 0,
    //         message: response.error.title
    //     };
    // } else {
    //     errorMessage = {
    //         success: false,
    //         status: 0,
    //         message: "Internal server error!"
    //     };
    // }
    // APIConfigService.errorFromApi.next(errorMessage);
    // return throwError(errorMessage);
  }

  isLoggedIn(): boolean {
    // return this.jwtHelper.isTokenExpired() !== true;
    return true;
  }

  static IsAuthRequired(apiEndPoint) {
    //return API.AUTHTOKEN_APPLIED_ENDPOINTS.indexOf(apiEndPoint) > -1;;
  }

  getHeadersWithAuthorization(apiEndPoint: string): HttpHeaders {
    // let langId = APIConfigService.getLanguage().toString();
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let authorizationData: any = "";
    let encr = secureStorage.hash("currentUser");
    // let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let currentUser;
    this.cookieService.check(encr) && (currentUser = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    this.cookieService.check(encr) && (authorizationData = currentUser.accessToken);
    return new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId,
      "authorization": authorizationData,
    });
  }

  static getLanguage() {
    if (getSecureItem("selectedLang")) {
      let lang = JSON.parse(
        getSecureItem("selectedLang")
      );
      return lang['langId'];
    } else {
      return 1;
    }
  }

  getAuthorityPinHeaders(password): HttpHeaders {
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    let headers;
    this.cookieService.check(encr) ? (headers = new HttpHeaders({
      "Content-Type": "application/json",
      authorization: accessToken.accessToken,
      "languageId": langId,
      "userPassword": password
    })) : (headers = new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId
    }));
    return headers;
  }

  getPostHeaders(): HttpHeaders {
    let langId = APIConfigService.getLanguage() ? APIConfigService.getLanguage().toString() : "1";
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    let headers;
    this.cookieService.check(encr) ? (headers = new HttpHeaders({
      "Content-Type": "application/json",
      authorization: accessToken.accessToken,
      "languageId": langId,
    })) : (headers = new HttpHeaders({
      "Content-Type": "application/json",
      "languageId": langId
    }));
    return headers;
  }

}
